// redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import modelReducer from "./modelSlice";
import sidebarReducer from "./sidebarSlice";
import sessionReducer from "./sessionSlice";
import chatReducer from "./chatSlice"; // 👈 Import chatSlice
import notificationReducer from "./notificationSlice";
import themeReducer from "./themeSlice";
import refreshReducer from "./refreshSlice"; // 👈 Import refreshSlice
import privacyReducer from "./privacySlice";
import uploadQueueReducer from './uploadQueueSlice';
import loadingReducer from "./loadingSlice";


export const store = configureStore({
  reducer: {
    model: modelReducer,
    sidebar: sidebarReducer,
    session: sessionReducer,
    chat: chatReducer, // 👈 Add it here
    notifications: notificationReducer, // 👈 Add notificationSlice
    theme: themeReducer,
    refresh: refreshReducer, // 👈 Add here
    privacy: privacyReducer,
    uploadQueue: uploadQueueReducer,
    // 🔥 ADD THIS LINE
    loading: loadingReducer,
  },
});
